import { render, staticRenderFns } from "./ExerciseLogicMultiple.vue?vue&type=template&id=524cdc9e&"
import script from "./ExerciseLogicMultiple.vue?vue&type=script&lang=js&"
export * from "./ExerciseLogicMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports